import { render, staticRenderFns } from "./ProveedoresCreate.vue?vue&type=template&id=2ae779d3&"
import script from "./ProveedoresCreate.vue?vue&type=script&lang=js&"
export * from "./ProveedoresCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports